import loaded from '@/scripts/utils/loaded.js';
import { getSetCookie, classHelper, ge } from '@/scripts/utils/legacy-dom.js';

// Page-activity counters kept in the `page-activity` cookie.
function pageActivityGetCookie() {
    let pageActivityCookie = getSetCookie('page-activity');
    try {
        pageActivityCookie = JSON.parse(pageActivityCookie);
    } catch (e) {
        /* not set yet */
    }
    if (!pageActivityCookie || typeof pageActivityCookie !== 'object') {
        pageActivityCookie = {pages: 0, scrolls: 0, touches: 0, clicks: 0};
    }
    return pageActivityCookie;
}

function pageActivityUpdate(type) {
    const pageActivityCookie = pageActivityGetCookie();
    pageActivityCookie[type]++;
    if (type === 'pages') pageActivityCookie.lastView = new Date().toISOString();
    getSetCookie('page-activity', JSON.stringify(pageActivityCookie));
}

function pageActivityInit() {
    let scrollTimeout;
    window.addEventListener('scroll', () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => pageActivityUpdate('scrolls'), 100);
    }, {passive: true});
    window.addEventListener('touchend', () => pageActivityUpdate('touches'));
    window.addEventListener('click', () => pageActivityUpdate('clicks'));
}

// `.fade-in` / `.fadeIn` / `.fadeIn2` start near-transparent (see the snippet's CSS) and are
// revealed once the page is ready.
function activateFadeIns() {
    const fadeIns = document.querySelectorAll('.fade-in');
    if (fadeIns.length) {
        setTimeout(() => fadeIns.forEach((el) => classHelper(el, 'a', 'active')), 2);
    }
    setTimeout(() => {
        document.querySelectorAll('.fadeIn, .fadeIn2').forEach((el) => classHelper(el, 'a', 'active'));
    }, 15);
}

// Outline the element reached with Tab.
function tabHighlight(e) {
    if (e.keyCode !== 9) return;
    classHelper(ge('.tab-active'), 'r', 'tab-active');
    classHelper(e.target, 'a', 'tab-active');
}

pageActivityUpdate('pages');
pageActivityInit();

loaded(() => {
    activateFadeIns();
    document.body.addEventListener('keyup', tabHighlight);
});
